import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../../../constants/Colors';
import { comparisonLineColor } from '../../../components/Home/HomeGraphLineSelector';

interface LegendProps {
  title: string,
  alternateTitle?: string,
  selectedColor?: string,
  alternateColor?: string,
  showComparison?: boolean,
}

const Legend = ({
  title, alternateTitle, selectedColor, alternateColor, showComparison,
}: LegendProps) => <View style={styles.legend}>
    <View style={[styles.legendIndicator, { backgroundColor: selectedColor }]} />
    <Text style={styles.legendLabel}>{title}</Text>
    {alternateTitle && <>
      <View style={[styles.legendIndicator, { backgroundColor: alternateColor }]} />
      <Text style={styles.legendLabel}>{alternateTitle}</Text>
    </>}
    {showComparison && <>
      <View style={[styles.legendIndicator, styles.legendIndicatorCompared]} />
      <Text style={styles.legendLabel}>{`${title} (compared)`}</Text>
    </>}
  </View>;

const styles = StyleSheet.create({
  legend: {
    flexDirection: 'row',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: Colors.light.hereworksWhite500,
    paddingTop: 8,
  },
  legendIndicator: {
    width: 16,
    height: 16,
    borderRadius: 4,
    marginEnd: 8,
    backgroundColor: Colors.light.hereworksBlue100,
  },
  legendIndicatorCompared: {
    backgroundColor: comparisonLineColor,
  },
  legendLabel: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    marginEnd: 24,
  },
});

export default Legend;
